import { useQuery } from '@tanstack/react-query';

import { dictionaryTypes } from '../types';

import { dictionaryApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getServiceTypes = (
  viewMode: dictionaryTypes.ViewMode
): Promise<dictionaryApiTypes.ListServiceTypesResponse> => {
  return axios.get('/service-types', { params: { viewMode } });
};

type QueryFnType = typeof getServiceTypes;

type UseGetServiceTypesOptions = {
  viewMode: dictionaryTypes.ViewMode;
  config?: QueryConfig<QueryFnType>;
};

export const useGetServiceTypes = ({ viewMode, config = {} }: UseGetServiceTypesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    // Opt out of the global refetchOnMount: false. Archive/restore invalidate
    // both viewMode keys, but only the mounted one is refetched — the other is
    // just marked stale and would be served from cache on the next mount.
    refetchOnMount: true,
    ...config,
    queryKey: ['service-types', viewMode],
    queryFn: () => getServiceTypes(viewMode),
  });
};
